/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Feat_PhotoInputs */

const cs_pm_feat_photo = /** @type {(inputs: Pm_Feat_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky`)
};

const en_pm_feat_photo = /** @type {(inputs: Pm_Feat_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Pm_Feat_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_feat_photo = /** @type {((inputs?: Pm_Feat_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Feat_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_feat_photo(inputs)
	return cs_pm_feat_photo(inputs)
});